export default "__VITE_ASSET__3AC$FAML__"